import React from 'react';
import { X } from 'lucide-react';

interface SourcingTagChipProps {
  active: boolean;
  isCustomTag: boolean;
  label: string;
  slug: string;
  onDelete: (slug: string) => void;
  onSelect: (slug: string) => void;
  deleteLabel: string;
}

export const SourcingTagChip: React.FC<SourcingTagChipProps> = ({
  active,
  isCustomTag,
  label,
  slug,
  onDelete,
  onSelect,
  deleteLabel,
}) => (
  <div className="group relative shrink-0">
    <button
      type="button"
      onClick={() => onSelect(slug)}
      className={`overflow-hidden rounded-full border px-4 py-1 font-body text-xs font-medium transition-colors ${
        active
          ? 'border-dark-invirtus bg-dark-invirtus text-light'
          : 'border-light-lila/60 bg-light text-dark-invirtus/65 hover:border-light-lila hover:text-dark-invirtus'
      }`}
    >
      <span
        className={`block whitespace-nowrap text-center transition-transform duration-150 ${
          isCustomTag ? 'group-hover:-translate-x-1.5' : ''
        }`}
      >
        {label}
      </span>
    </button>

    {isCustomTag && (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onDelete(slug);
        }}
        className={`pointer-events-none absolute right-0.5 top-1/2 inline-flex h-4 w-4 -translate-y-1/2 items-center justify-center rounded-full opacity-0 transition-all duration-150 group-hover:pointer-events-auto group-hover:opacity-100 ${
          active
            ? 'text-light/80 hover:bg-light-lila/60 hover:text-red-400'
            : 'text-dark-invirtus/55 hover:bg-dark-invirtus-soft hover:text-red-600'
        }`}
        title={deleteLabel}
        aria-label={deleteLabel}
      >
        <X className="h-3 w-3" />
      </button>
    )}
  </div>
);
